var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LabelField',{attrs:{"label":_vm.$t('event_organizer')}},[_c(_setup.EventOrganizerSelect,{attrs:{"event":_vm.record,"required":_setup.eoMandatory,"show-new":""},on:{"selected":function($event){return _setup.onEventOrganizerSelect($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }